import api from './common/services/liferay/api';
import { Liferay as LiferayAPI } from './common/services/liferay/liferay';



export async function getTraducciones() {
	let promesa = await api('o/c/literalcontactos/scopes/' + LiferayAPI.ThemeDisplay.getScopeGroupId() + '?pageSize=50')
		.catch((e) => console.error("Error en llamada traducciones: " + e));
	let final = await promesa.json();
	return final.items[0];
}


export function traducir(letiableTraducciones) {
	let langActual = LiferayAPI.ThemeDisplay.getLanguageId();
	let texto = "";
	switch (langActual) {
		case 'es_ES':
			texto = letiableTraducciones?.es_ES;
			break;
		case 'en_US':
			texto = letiableTraducciones?.en_US;
			break;
		case 'ca_ES':
			texto = letiableTraducciones?.ca_ES;
			break;
		case 'eu_ES':
			texto = letiableTraducciones?.eu_ES;
			break;
		case 'gl_ES':
			texto = letiableTraducciones?.gl_ES;
			break;
		case 'de_DE':
			texto = letiableTraducciones?.de_DE;
			break;
		case 'fr_FR':
			texto = letiableTraducciones?.fr_FR;
			break;
		case 'it_IT':
			texto = letiableTraducciones?.it_IT;
			break;
		case 'pt_PT':
			texto = letiableTraducciones?.pt_PT;
			break;
		default:
			return undefined;
	}

	if (texto && texto != "") {
		return texto;
	} else {
		return letiableTraducciones?.es_ES;
	}
}

export async function getEmailContacto() {
	var promesaUrl = await api('o/c/configuracions/scopes/' + LiferayAPI.ThemeDisplay.getScopeGroupId())
		.catch((e) => console.error("Error en llamada url formulario: " + e));
	var final = await promesaUrl.json();
	return [final.items[0].emailOrigen,final.items[0].emailContacto];
}

function procesarEmails(emailContacto) {
	const emails = emailContacto.split(";").map(email => email.trim());
	const primerCorreo = emails[0];
	const restoCorreos = emails.slice(1).join(","); // Une los correos restantes con comas
	return [primerCorreo, restoCorreos];
}

export async function getEmailsContactoMultiple() {
	try {
		const promesaUrl = await api(`o/c/configuracions/scopes/${LiferayAPI.ThemeDisplay.getScopeGroupId()}`);
		const final = await promesaUrl.json();
		const emailContacto = final.items[0].emailContacto;
		const [correoPrincipal, correosCopia] = procesarEmails(emailContacto);
		return {
			correoPrincipal,
			correosCopia
		};
	} catch (error) {
		console.error("Error en llamada a la API:", error);
		return null;
	}
}

export async function getUrlPrivacidad() {
	var promesa = await api('o/c/configuracions/scopes/' + LiferayAPI.ThemeDisplay.getScopeGroupId())
		.catch((e) => console.error("Error al sacar la url de politica de privacidad " + e));
	var final = await promesa.json();
	return final.items[0].urlPoliticaPrivacidad;
}

export async function getAeropuertos() {
	var promesa = await api('o/c/estacions/scopes/' + LiferayAPI.ThemeDisplay.getScopeGroupId() + '?pageSize=100')
		.catch((e) => console.error("Error en llamada aeropuertos: " + e));
	var final = await promesa.json();
	var listaTrad = [];
	for await (let aero of final?.items) {
		aero = {
			...aero,
			nombre: traducir(aero.nombre_i18n)
		}
		listaTrad.push(aero);
	}
	final.items = listaTrad.sort((a, b) => a.nombre.localeCompare(b.nombre));;
	return final;
}

export async function mandarEmail(formPintar, subject) {
	logger(formPintar);
	const [emailContactoEnvia, emailContactoDestino]= await getEmailContacto();
	const emailContactoRecibe = await procesarEmails(formPintar.aeropuertoEmail ? formPintar.aeropuertoEmail : emailContactoDestino);
	const [correoPrincipal, correosCopia] = emailContactoRecibe;
	const url = 'o/notification/v1.0/notification-queue-entries';
	const correo = formPintar.email;
	const nombre = formPintar.nombre;
	const apellidos= formPintar.apellidos;
	const telefono = formPintar.numero;
	const aeropuerto = formPintar.aeropuertoObj;
	const aeropuertoEmail = formPintar.aeropuertoEmail;
	const mensaje = formPintar.mensaje;

	var cuerpoHTML = '<p>Nombre: ' + nombre + '</p><p>Apellidos: ' + apellidos + '</p><p>Email: ' + correo + '</p><p>Teléfono: ' + telefono + '</p>';
	if (aeropuerto != "")
		cuerpoHTML += '<p>Aeropuerto: ' + aeropuerto.nombre + '</p>'
			+ '<p>Id: ' + aeropuerto.id + '</p>'
			+ '<p>Email responsable: ' + aeropuertoEmail + '</p>';
	cuerpoHTML += '<p>Mensaje: ' + mensaje + '</p>';

	const body = JSON.stringify({
		"body": cuerpoHTML,
		"recipients": [
			{
				"fromName": "Contacto Spain Transfers : " + nombre + " " + apellidos,
				"from": emailContactoEnvia,
				"to": correoPrincipal,
				"cc": correosCopia
			}
		],
		"subject": subject,
		"type": 'email'
	});
	logger(body);
	try {
		const response = await api(url, {
			method: 'POST',
			body: body
		});

		// Procesar la respuesta
		if (response.ok) {
			const jsonResponse = await response.json();
			logger('Email enviado correctamente:', jsonResponse);
			return jsonResponse;
		} else {
			const errorResponse = await response.text();
			console.error('Error al enviar email:', errorResponse);
			throw new Error(`Error al enviar email: ${errorResponse}`);
		}
	} catch (error) {
		console.error('Error en la petición:', error);
		throw error;
	}
}

export function logger(param){
	if(!process.env.REACT_APP_PRO){
	  console.log(param);
	}
}


export default Llamadas;